(function () {
  document.querySelectorAll('.product-form__controls').forEach(function (fieldset) {
    var groupName = fieldset.querySelector('.product-form__group-name');
    if (!groupName) return;

    var optionName = groupName.textContent.trim();
    groupName.innerHTML =
      optionName + ': <span class="product-form__group-value"></span>';

    function update() {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      var valueEl = groupName.querySelector('.product-form__group-value');
      if (checked && valueEl) valueEl.textContent = checked.value;
    }

    update();
    fieldset.addEventListener('change', update);
  });
})();
